import { api } from './api';

const get = async type => {
  try {
    const result = await api.get(`/v2/activation/mondayConfig?type=${type}`);
    return result.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getColumns = async id => {
  try {
    const result = await api.get(`/v2/activation/mondayConfig/columns/${id}`);
    return result.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getMapping = async type => {
  try {
    const result = await api.get(
      `/v2/activation/mondayMapping?importType=${type}`
    );
    return result.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const create = async data => {
  try {
    const result = await api.post(`/v2/activation/mondayConfig`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const update = async (id, data) => {
  try {
    const result = await api.put(`/v2/activation/mondayConfig/${id}`, data);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const deleteById = async id => {
  try {
    const result = await api.delete(`/v2/activation/mondayConfig/${id}`);
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const syncCampaigns = async (id, data) => {
  try {
    const result = await api.post(
      `/v2/activation/mondayConfig/sync/${id}`,
      data
    );
    return result;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getLastSyncTask = async id => {
  try {
    const result = await api.get(`/v2/activation/mondayConfig/last/${id}`);
    return result.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const duplicateBoard = async (id, data) => {
  try {
    await api.post(`/v2/activation/mondayConfig/duplicate/${id}`, data);
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export default {
  get,
  create,
  update,
  deleteById,
  getColumns,
  getMapping,
  syncCampaigns,
  getLastSyncTask,
  duplicateBoard
};
